import React from 'react';
import Modal from 'react-bootstrap/Modal';
import { Button } from '../../../common-components/Button/Button';
import { ShopLocation } from '../../../models/ShopLocation';
import {
  formatDateTime,
  formatDays,
  getAssemblyTypeText,
  getYesNoText
} from '../locationUi';
import {
  EmptyValue,
  InfoGrid,
  InfoItem,
  InfoLabel,
  InfoValue,
  Section,
  SectionTitle,
  Subtitle
} from './styles';

interface IModalLocationDetailsProps {
  location: ShopLocation;
  close: () => void;
}

const ModalLocationDetails: React.FC<IModalLocationDetailsProps> = ({
  location,
  close
}) => {

  return (
    <Modal
      show={true}
      onHide={() => close()}
      size='lg'
    >
      <Modal.Header closeButton>
        <div>
          <Modal.Title>{location.name}</Modal.Title>
          <Subtitle>ID Shopify {location.shopifyId}</Subtitle>
        </div>
      </Modal.Header>

      <Modal.Body style={{ maxHeight: '75vh', overflowY: 'auto' }}>
        <Section>
          <SectionTitle>Geral</SectionTitle>
          <InfoGrid>
            {info('ID Shopify', location.shopifyId)}
            {info('Nome', location.name)}
            {info('Código de integração', location.integrationCode)}
            {info('Omnichannel', getYesNoText(location.isOmnichannel))}
            {info('Estoque global', getYesNoText(location.isGlobalStock))}
            {info('Tipo de montagem', getAssemblyTypeText(location.assemblyType))}
            {info('Corta lentes em máquina', getYesNoText(location.cutLensesByMachine))}
          </InfoGrid>
        </Section>

        <Section>
          <SectionTitle>Gestão de pedidos e comunicação</SectionTitle>
          <InfoGrid>
            {info('Usa Sislog para gestão de pedidos', getYesNoText(location.manageOrderInSislog))}
            {info('Usa Sislog desde', formatDateTime(location.manageOrderInSislogSinceDate))}
            {info('Comunica prazo ao cliente', getYesNoText(location.communicateClientDeadline))}
            {info('Comunica prazo para pedidos a partir de', formatDateTime(location.communicateClientDeadlineForOrderAfterDate))}
            {info('Comunicação transacional ativa desde', formatDateTime(location.transactionalCommunicationEnabledSinceDate))}
          </InfoGrid>
        </Section>

        <Section>
          <SectionTitle>Contato e funcionamento</SectionTitle>
          <InfoGrid>
            {info('E-mail', location.emailAddress, true)}
            {info('Contato', location.storeContactInfo, true)}
            {info('Horário de funcionamento', location.storeOpeningHours, true)}
          </InfoGrid>
        </Section>

        <Section>
          <SectionTitle>Prazos para o cliente</SectionTitle>
          <InfoGrid>
            {info('Sem lentes (dias úteis)', formatDays(location.workingDaysForOrderDeliveryWithoutLenses))}
            {info('Lentes visão simples (dias úteis)', formatDays(location.workingDaysForOrderDeliveryWithSingleVisionLenses))}
            {info('Lentes multifocais (dias úteis)', formatDays(location.workingDaysForOrderDeliveryWithMultifocalLenses))}
            {info('Zerezes em casa (dias corridos)', formatDays(location.daysForOrderDeliveryHTO))}
          </InfoGrid>
        </Section>

        <Section>
          <SectionTitle>Prazos internos</SectionTitle>
          <InfoGrid>
            {info('Sem lentes (dias úteis)', formatDays(location.internalWorkingDaysForOrderDeliveryWithoutLenses))}
            {info('Lentes visão simples (dias úteis)', formatDays(location.internalWorkingDaysForOrderDeliveryWithSingleVisionLenses))}
            {info('Lentes multifocais (dias úteis)', formatDays(location.internalWorkingDaysForOrderDeliveryWithMultifocalLenses))}
            {info('Zerezes em casa (dias corridos)', formatDays(location.internalDaysForOrderDeliveryHTO))}
          </InfoGrid>
        </Section>

        <Section>
          <InfoGrid>
            {info('Última alteração', formatDateTime(location.updatedAt))}
          </InfoGrid>
        </Section>
      </Modal.Body>
      <Modal.Footer>
        <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Button text={'Fechar'} click={() => close()} />
        </div>
      </Modal.Footer>
    </Modal>
  );

  function info(label: string, value?: React.ReactNode, wide: boolean = false) {
    const empty = value === undefined || value === null || value === '';
    return (
      <InfoItem wide={wide}>
        <InfoLabel>{label}</InfoLabel>
        <InfoValue>{empty ? <EmptyValue>não informado</EmptyValue> : value}</InfoValue>
      </InfoItem>
    );
  }
}

export { ModalLocationDetails };
